// antd theme tokens, replacing the old less-variable overrides
// (src/styles/overrides.less, removed with antd v5+). Values carried over:
// @primary-color, @layout-header-height (48px), @layout-header-background.
// borderRadius restores the v4-era 2px sharpness (see
// _do_not_build/elsewhere/ANTD6_DESIGN_RESTORATION.md entry 1); Modal and
// Card containers stay softer on purpose while the controls inside resolve
// against the 2px seed.
const antdTheme = {
	token: {
		colorPrimary:  '#3d5a80',
		borderRadius:  2,
	},
	components: {
		Layout: {
			headerHeight: 48,
			headerBg:     '#3d5a80',
		},
		Modal: {
			borderRadiusLG: 8,
		},
		Card: {
			borderRadiusLG: 6,
		},
	},
};

export default antdTheme;
